import { useState, useEffect, useCallback } from 'react';
import { useAdminSession } from '../context/AdminSessionContext';
import { useAbortableTask } from './useAbortableTask';

export function useAdminInbox() {
  const { api } = useAdminSession();
  const task = useAbortableTask();
  const [data, setData] = useState({ demos: [], leads: [], chats: [], alerts: [] });
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const load = useCallback(async () => {
    const operation = task.start(); setLoading(true); setFailed(false);
    try {
      const [demos, leads, chats, alerts] = await Promise.all(['/demo-requests', '/leads', '/chat-sessions', '/notifications'].map(path => api.get(path, operation.signal)));
      if (task.isCurrent(operation)) setData({ demos, leads, chats, alerts });
    } catch (error) { if (task.isCurrent(operation) && error.status !== 401) setFailed(true); }
    finally { if (task.isCurrent(operation)) setLoading(false); }
  }, [api, task]);
  useEffect(() => { load(); return task.cancel; }, [load, task]);
  return { ...data, loading, failed, load };
}